import React from "react";
import WorkflowDataStripWidgetSettingsRow from "./WorkflowDataStripWidgetSettingsRow.jsx";
import WorkflowDatastripBeforeDatasetSettings from "./WorkfloDataStripBeforeDatasetSettings.jsx";
import ChartDatasetSettings from "../../settings_sidebar/ChartDatasetSettings.jsx";

function WorkflowDataStripWidgetSettings({ widgetId }) {
    return (
        <ChartDatasetSettings
            dataset_settings_props={{
                DatasetSettingsRowComponent: WorkflowDataStripWidgetSettingsRow,
                elementTitle: I18n.t('task'),
                sectionTitle: I18n.t('task_details')
            }}
            ChartSettingsComponent={WorkflowDatastripBeforeDatasetSettings}
            widgetId={widgetId}
        />
    )
}

export default WorkflowDataStripWidgetSettings;
